import { ConfigFilterItem, ConfigItem } from 'Core/interfaces/filters'

export enum WastestreamSearchResultFields {
	wastestreamId = 'searchById',
	wastestreamName = 'searchByName',
	serviceSiteName = 'searchByServiceSiteName',
	refCode = 'searchByRefCode',
	supplierLocation = 'searchBySupplierLocation'
}

export enum WastestreamFilterFields {
	serviceSite = 'ServiceSiteId',
	refCode = 'RefCode',
	supplierLocation = 'SupplierLocationName'
}

export declare namespace Wastestream {
	interface Basic extends NullableEntity {
		serviceSite: NullableEntity | null
		supplierLocation: NullableEntity | null
		refCode: BasicString
		isActive: boolean
	}

	interface PhysicalCharacteristic {
		id: number
		description: BasicString
		physicalCharacteristic: BasicString
		physicalCharacteristicId: number
	}

	interface HazCode {
		id: number
		hazCode: IdNullableNameCode | null
	}

	interface Detailed extends NullableEntity {
		refCode: BasicString
		profileFilename: BasicString
		technicalDescription: BasicString
		isReportableQuantity: boolean
		ergNumber: BasicString
		specialHandlingDescription: BasicString
		lastEvaluationDate: BasicString
		reEvaluationDate: BasicString
		comments: BasicString
		dotLabel1FileName: BasicString
		dotLabel2FileName: BasicString
		dotLabel3FileName: BasicString
		dotShipping: NullableEntity | null
		dotShippingPacking: NullableEntity | null
		serviceSite: NullableEntity | null
		supplierLocation: NullableEntity | null
		companyCategory: NullableNameCode | null
		epaFormCode: NullableEntity | null
		epaSourceCode: NullableEntity | null
		managementMethod: NullableNameCode | null
		physicalCharacteristics: PhysicalCharacteristic[] | null
		epaHazCodes: HazCode[] | null
		stateHazCodes: HazCode[] | null
	}
	namespace Filter {
		interface Config {
			[WastestreamFilterFields.serviceSite]: ConfigFilterItem<string, string>
			[WastestreamFilterFields.refCode]: ConfigFilterItem<string, string>
			[WastestreamFilterFields.supplierLocation]: ConfigFilterItem<string, string>
		}
	}

	namespace Search {
		interface Config {
			[WastestreamSearchResultFields.wastestreamId]: ConfigItem<WastestreamSearchResultFields>
			[WastestreamSearchResultFields.wastestreamName]: ConfigItem<WastestreamSearchResultFields>
		}

		interface Result {
			[WastestreamSearchResultFields.wastestreamId]: Entity[]
			[WastestreamSearchResultFields.wastestreamName]: Entity[]
			[WastestreamSearchResultFields.refCode]: string[]
			[WastestreamSearchResultFields.supplierLocation]: string[]
		}

		interface RefCodeResponse {
			refCodes: string[]
		}

		interface SupplierLocationResponse {
			supplierLocations: string[]
		}
	}
}
